// extracted by mini-css-extract-plugin
export default {"containerText":"TabUno_containerText__wuTuL","textField":"TabUno_textField__Iq6oV","textFieldDisabled":"TabUno_textFieldDisabled__AV4cH"};